const SET_TAF_INFO = (state, data) => {
  state.tafInfo = data
}
const SET_REFERRAL_DATA = (state, data) => {
  state.referralData = data
}
export default {
  SET_TAF_INFO,
  SET_REFERRAL_DATA
}



// WEBPACK FOOTER //
// ./src/store/modules/user/taf/mutations.js